import view from './view';

window.__view__ = view("#app");


// WEBPACK FOOTER //
// ./src/main.js